import { SLOTS } from '../../lib/slots';
import { FlowAPI } from '@wix/yoshi-flow-editor';
import { createSettingsClient } from '@wix/search-settings-client';
import { getSlot } from '../getSlot';
import { getComponentRef } from '../getComponentRef';
import { productsAppDefId } from '../constants/appDefIds';
import { productWidgetComponentId } from '../constants/componentIds';
import { EditorSDK } from '@wix/editor-platform-sdk-types';
import { EditorAppContext } from '../types';

export const installProductsWidget = async ({
  editorSDK,
  appDefinitionId,
  flowAPI,
}: {
  editorSDK: EditorSDK;
  appDefinitionId: string;
  flowAPI: FlowAPI;
}) => {
  const productsSlot = await getSlot(editorSDK, SLOTS.products.id);

  const pluggableSlotId = (productsSlot as { id?: string } | undefined)?.id;

  if (productsSlot && !productsSlot.pluginInfo) {
    try {
      await editorSDK.document.transactions.runAndWaitForApproval(
        appDefinitionId,
        async () => {
          if (pluggableSlotId) {
            const searchCompRef = await getComponentRef(editorSDK);
            if (searchCompRef) {
              await editorSDK.tpa.widgetPlugins.addWidgetPlugin(
                appDefinitionId,
                {
                  hostCompRef: searchCompRef,
                  slotId: pluggableSlotId,
                  widgetPluginPointer: {
                    appDefinitionId: productsAppDefId,
                    widgetId: productWidgetComponentId,
                  },
                },
              );
            }
          } else {
            await editorSDK.tpa.widgetPlugins.addWidgetPlugin(appDefinitionId, {
              slotCompRef: productsSlot.compRef!,
              widgetPluginPointer: {
                appDefinitionId: productsAppDefId,
                widgetId: productWidgetComponentId,
              },
            });
          }
        },
      );
    } catch (e) {
      // TODO: report error
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
  await setProductSlotInstalled(flowAPI);
};

export const isProductSlotInstalled = async (flowAPI: FlowAPI) => {
  const httpClient = flowAPI.httpClient;
  const settingsClient = createSettingsClient({
    httpClient,
  });
  const appSettings = await settingsClient.getSaved();
  return appSettings.isProductSlotInstalled;
};

export const setProductSlotInstalled = async (flowAPI: FlowAPI) => {
  const httpClient = flowAPI.httpClient;
  const settingsClient = createSettingsClient({
    httpClient,
  });
  try {
    await settingsClient.set('isProductSlotInstalled', true);
  } catch (error) {
    reportError(error);
  }
};

export const resetProductSlotInstalled = async (
  appContext: EditorAppContext,
) => {
  const { flowAPI, reportError } = appContext;
  const httpClient = flowAPI.httpClient;
  const settingsClient = createSettingsClient({
    httpClient,
  });
  try {
    await settingsClient.set('isProductSlotInstalled', false);
  } catch (error) {
    reportError(error);
  }
};
